import React, { useEffect, useRef, useState } from 'react';
import { gsap } from 'gsap';
import '../styles/Navbar.css';

const links = [
  { label: 'Home',     id: 'hero' },
  { label: 'About',    id: 'about' },
  { label: 'Services', id: 'services' },
  { label: 'Projects', id: 'projects' },
  { label: 'Skills',   id: 'skills' },
  { label: 'Contact',  id: 'contact' },
];

const Navbar = () => {
  const navRef   = useRef(null);
  const [active,    setActive]    = useState('hero');
  const [scrolled,  setScrolled]  = useState(false);
  const [menuOpen,  setMenuOpen]  = useState(false);

  // Entrance animation
  useEffect(() => {
    gsap.fromTo(navRef.current,
      { y: -80, opacity: 0 },
      { y: 0, opacity: 1, duration: 1, ease: 'power3.out', delay: 0.3 }
    );
  }, []);

  // Close menu on outside click
  useEffect(() => {
    if (!menuOpen) return;
    const handler = (e) => {
      if (!navRef.current.contains(e.target)) setMenuOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [menuOpen]);

  // Shrink on scroll + active section tracking
  useEffect(() => {
    const sectionEls = links.map(l => document.getElementById(l.id)).filter(Boolean);

    const onScroll = () => {
      setScrolled(window.scrollY > 50);

      let current = 'hero';
      sectionEls.forEach(el => {
        if (window.scrollY >= el.offsetTop - window.innerHeight / 3) {
          current = el.id;
        }
      });
      setActive(current);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setMenuOpen(false);
  };

  return (
    <nav ref={navRef} className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="nav-inner">
        <button className="nav-logo" onClick={() => scrollTo('hero')}>
          MM<span className="logo-dot">.</span>
        </button>

        <ul className={`nav-links ${menuOpen ? 'open' : ''}`}>
          {links.map(({ label, id }) => (
            <li key={id}>
              <button
                className={`nav-link ${active === id ? 'active' : ''}`}
                onClick={() => scrollTo(id)}
              >
                {label}
                <span className="nav-link-underline" />
              </button>
            </li>
          ))}
        </ul>

        <a
          href="https://www.linkedin.com/messaging/compose/?recipient=momenmedhatsalem"
          target="_blank"
          rel="noopener noreferrer"
          className="hire-btn"
        >
          <span className="hire-btn-text">Hire Me</span>
          <span className="hire-btn-icon">
            <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
              <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
            </svg>
          </span>
        </a>

        <button
          className={`hamburger ${menuOpen ? 'open' : ''}`}
          onClick={() => setMenuOpen(p => !p)}
          aria-label="Toggle menu"
        >
          <span /><span /><span />
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
